import { render, staticRenderFns } from "./baddebt.vue?vue&type=template&id=1309b0a8&scoped=true"
import script from "./baddebt.vue?vue&type=script&lang=js"
export * from "./baddebt.vue?vue&type=script&lang=js"
import style0 from "./baddebt.vue?vue&type=style&index=0&id=1309b0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1309b0a8",
  null
  
)

export default component.exports